'use client';

import { useEffect, useState } from 'react';

export const useDebounceValue = <T>(value: T, delay: number): T | null => {
    const [debouncedValue, setDebouncedValue] = useState<T | null>(null);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
};
